import { DashboardV2ApiClient } from '@fourthwall/services/dist/DashboardV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useUnfulfilledOrdersCountQuery = createQueryHook(
  DashboardV2ApiClient.countUnfulfilledOrders,
  {
    queryKey: ['unfulfilledOrderCount'],
  },
)
